import { useQuery as n } from "@tanstack/vue-query";
import { computed as y, toValue as a } from "vue";
const o = ["statistics"], m = 5, p = 60, l = 1e3, u = m * p * l, c = {
  all: o,
  domains: (s) => [...o, "domains", s],
  spots: (s) => [...o, "spots", s],
  spotsTop: (s) => [...o, "spots-top", s],
  domainsBySpot: (s) => [...o, "domains-by-spot", s],
  childCounts: (s) => [...o, "child-counts", s],
  totals: (s) => [...o, "totals", s],
  campaignTimeseries: (s) => [...o, "campaign-timeseries", s],
  metrics: (s) => [...o, "metrics", s],
  campaignRollup: (s) => [...o, "campaign-rollup", s],
  campaignTotals: (s) => [...o, "campaign-totals", s],
  reports: () => [...o, "reports"],
  reportDimensions: (s) => [...o, "report-dimensions", s],
  reportMetrics: (s) => [...o, "report-metrics", s],
  reportGrouped: (s) => [...o, "report-grouped", s],
  reportValues: (s) => [...o, "report-values", s],
  query: (s) => [...o, "query", s],
  segments: () => [...o, "segments"],
  marketplace: (s) => [...o, "marketplace", s],
  marketplaceDomains: (s) => [...o, "marketplace-domains", s]
}, S = (s, t, e) => {
  const r = y(() => c.domains(a(t)));
  return n({
    staleTime: u,
    ...e,
    queryKey: r,
    queryFn: async ({ signal: i }) => s.statistics.domains(a(t), { signal: i })
  });
}, d = (s, t, e) => {
  const r = y(() => c.spots(a(t)));
  return n({
    staleTime: u,
    ...e,
    queryKey: r,
    queryFn: async ({ signal: i }) => s.statistics.spots(a(t), { signal: i })
  });
}, g = ({
  queryClient: s,
  client: t,
  input: e,
  meta: r
}) => s.fetchQuery({
  queryKey: c.spots(e),
  queryFn: ({ signal: i }) => t.statistics.spots(e, { signal: i }),
  staleTime: 0,
  ...r && { meta: r }
}), K = (s, t, e) => {
  const r = y(() => c.campaignTimeseries(a(t)));
  return n({
    staleTime: u,
    ...e,
    queryKey: r,
    queryFn: async ({ signal: i }) => s.statistics.campaignTimeseries(a(t), { signal: i })
  });
}, F = (s, t, e) => {
  const r = y(() => c.metrics(a(t)));
  return n({
    staleTime: u,
    ...e,
    queryKey: r,
    queryFn: async ({ signal: i }) => s.statistics.metrics(a(t), { signal: i })
  });
}, C = (s, t, e) => {
  const r = y(() => c.campaignRollup(a(t)));
  return n({
    ...e,
    queryKey: r,
    queryFn: async ({ signal: i }) => s.statistics.campaignRollup(a(t), { signal: i })
  });
}, D = (s, t, e) => {
  const r = y(() => c.campaignTotals(a(t)));
  return n({
    ...e,
    queryKey: r,
    queryFn: async ({ signal: i }) => s.statistics.campaignTotals(a(t), { signal: i })
  });
}, I = (s, t, e) => {
  const r = y(() => c.totals(a(t)));
  return n({
    staleTime: u,
    ...e,
    queryKey: r,
    queryFn: async ({ signal: i }) => s.statistics.totals(a(t), { signal: i })
  });
}, M = (s, t, e) => {
  const r = y(() => c.spotsTop(a(t)));
  return n({
    staleTime: u,
    ...e,
    queryKey: r,
    queryFn: async ({ signal: i }) => s.statistics.spotsTop(a(t), { signal: i })
  });
}, h = ({
  queryClient: s,
  client: t,
  input: e,
  meta: r
}) => s.fetchQuery({
  queryKey: c.domainsBySpot(e),
  queryFn: ({ signal: i }) => t.statistics.domainsBySpot(e, { signal: i }),
  staleTime: 0,
  ...r && { meta: r }
}), k = (s, t, e) => {
  const r = y(() => c.childCounts(a(t)));
  return n({
    staleTime: u,
    ...e,
    queryKey: r,
    queryFn: async ({ signal: i }) => s.statistics.childCounts(a(t), { signal: i })
  });
}, E = (s, t) => n({
  staleTime: u,
  ...t,
  queryKey: c.reports(),
  queryFn: async ({ signal: e }) => s.statistics.reports(void 0, { signal: e })
}), f = (s, t, e) => n({
  staleTime: u,
  ...e,
  queryKey: y(() => c.reportDimensions(a(t))),
  queryFn: async ({ signal: r }) => s.statistics.reportDimensions(a(t), { signal: r })
}), R = (s, t, e) => n({
  staleTime: u,
  ...e,
  queryKey: y(() => c.reportMetrics(a(t))),
  queryFn: async ({ signal: r }) => s.statistics.reportMetrics(a(t), { signal: r })
}), _ = (s, t, e) => n({
  ...e,
  queryKey: y(() => c.reportGrouped(a(t))),
  queryFn: async ({ signal: r }) => s.statistics.reportGrouped(a(t), { signal: r })
}), N = (s, t, e) => n({
  ...e,
  queryKey: y(() => c.reportValues(a(t))),
  queryFn: async ({ signal: r }) => s.statistics.reportValues(a(t), { signal: r })
}), Q = (s, t, e) => n({
  staleTime: 1 / 0,
  ...e,
  queryKey: y(() => c.query(a(t))),
  queryFn: async ({ signal: r }) => s.statistics.getQuery(a(t), { signal: r })
}), A = (s, t) => n({
  staleTime: u,
  ...t,
  queryKey: c.segments(),
  queryFn: async ({ signal: e }) => s.statistics.segments(void 0, { signal: e })
}), B = (s, t, e) => n({
  ...e,
  queryKey: y(() => c.marketplace(a(t))),
  queryFn: async ({ signal: r }) => s.statistics.marketplace(a(t), { signal: r })
}), V = async ({
  queryClient: s,
  client: t,
  input: e
}) => s.fetchQuery({
  queryKey: c.marketplaceDomains(e),
  queryFn: async ({ signal: r }) => t.statistics.marketplaceDomains(e, { signal: r })
});
export {
  h as fetchDomainsBySpotStatistics,
  V as fetchMarketplaceDomains,
  g as fetchSpotStatistics,
  c as statisticsKeys,
  C as useCampaignRollup,
  K as useCampaignTimeseries,
  D as useCampaignTotals,
  k as useChildCounts,
  S as useDomainStatistics,
  B as useMarketplace,
  d as useSpotStatistics,
  F as useStatisticsMetrics,
  f as useStatisticsReportDimensions,
  _ as useStatisticsReportGrouped,
  R as useStatisticsReportMetrics,
  N as useStatisticsReportValues,
  E as useStatisticsReports,
  Q as useStatisticsSavedQuery,
  A as useStatisticsSegments,
  M as useTopSpotStatistics,
  I as useTotalStatistics
};
//# sourceMappingURL=queries.js.map
